import React from "react";

const StatsCard = ({ item }) => {
    return (
        <div className="bg-white rounded-[14px] border border-[#e4e5e7] p-[18px] flex flex-col gap-[12px] hover:shadow-sm transition-all">

            {/* Top row */}
            <div className="flex items-center justify-between">

                {/* Icon */}
                <div
                    className="w-[36px] h-[36px] rounded-[10px] flex items-center justify-center"
                    style={{ background: item.bgColor }}
                >
                    <div style={{ color: item.color }}>
                        {item.icon}
                    </div>
                </div>

                {/* Trend */}
                <div className="flex items-center gap-[4px]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-[12px] h-[12px]"
                        style={{ color: item.color }}
                    >
                        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                        <polyline points="16 7 22 7 22 13" />
                    </svg>

                    <span
                        className="text-[11px] font-medium"
                        style={{ color: item.color }}
                    >
                        {item.trend}
                    </span>
                </div>
            </div>

            {/* Content */}
            <div>
                <p className="font-semibold text-[28px] text-[#212326] mb-[2px]">
                    {item.value}
                </p>
                <p className="text-[12px] text-[#717182] font-semibold">
                    {item.label}
                </p>
            </div>
        </div>
    );
};

export default StatsCard;